"use strict";

exports.__esModule = true;
exports.RCE_FILE_UPLOAD_FAILURE = exports.RCE_FILE_UPLOAD_LIMITED = exports.RCE_FILE_TOO_BIG = exports.RCE_FILE_DOWNLOAD_WILL_BEGIN_SHORTLY = void 0;
var RCE_FILE_DOWNLOAD_WILL_BEGIN_SHORTLY = 'file-download-will-begin-shortly';
exports.RCE_FILE_DOWNLOAD_WILL_BEGIN_SHORTLY = RCE_FILE_DOWNLOAD_WILL_BEGIN_SHORTLY;
var RCE_FILE_TOO_BIG = 'file-too-big';
exports.RCE_FILE_TOO_BIG = RCE_FILE_TOO_BIG;
var RCE_FILE_UPLOAD_LIMITED = 'file-upload-limited';
exports.RCE_FILE_UPLOAD_LIMITED = RCE_FILE_UPLOAD_LIMITED;
var RCE_FILE_UPLOAD_FAILURE = 'file-upload-failure';
exports.RCE_FILE_UPLOAD_FAILURE = RCE_FILE_UPLOAD_FAILURE;